import React from 'react';
import * as colors from '../colorConstants';
import CustomSpinner from '../CustomSpinner/CustomSpinner';
import { Link, Button, ExternalLink, SpinnerWrapper, ArrowIcon } from './IconButton.styles';

const IconButton = (props) => {
  const Component = props.to ? Link : Button;
  const componentProps = props.to ? { to: props.to } : { onClick: props.onClick };

  if (props.isExternal) {
    return (
      <ExternalLink
        href={props.to}
        src={props.src}
        hoversrc={props.hoverSrc}
        $islogo={props.isLogo}
        $topborder={props.topBorder}
        $botborder={props.botBorder}
        $withborders={props.withBorders}
        target={props.target}
        rel={props.rel}
      >
        {!!props.label && props.label}
      </ExternalLink>
    );
  }

  return (
    <Component
      {...componentProps}
      $topborder={props.topBorder}
      $botborder={props.botBorder}
      $withborders={props.withBorders}
      disableclicks={props.showSpinner}
      src={props.src}
      hoversrc={props.hoverSrc}
      $islogo={props.isLogo}
      showspinner={props.showSpinner}
      target={props.target}
    >
      {props.showSpinner && (
        <SpinnerWrapper>
          <CustomSpinner size={8} gutter={-1} color={colors.darkGray7} />
        </SpinnerWrapper>
      )}
      {props.withArrow && <ArrowIcon rotate={props.rotate} />}
      {!!props.label && props.label}
    </Component>
  );
};

export default IconButton;
